import { useMutation, useQueryClient } from "@tanstack/react-query";
import { vinculosApi } from "../api/vinculosApi";
import { trackEvent } from "../../../shared/lib/analytics";
import { invalidateVinculoQueries } from "./invalidateVinculoQueries";

// Criar um vínculo afeta todas as telas derivadas (dashboard, KPIs, calendário,
// recebíveis) — a invalidação ampla garante que tudo recarregue sem prop drilling.
export function useCreateVinculoMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vinculosApi.create,
    onSuccess: () => {
      trackEvent("vinculo_criado");
      invalidateVinculoQueries(queryClient);
    },
  });
}
